<!--
 * File: Navbar.vue
 * Project: timo
 * File Created: Monday, 21st September 2020 5:59:45 pm
 * Author: Timo Zacherl
 * License: MPL-2.0
 * 
 * -----
 * Last Modified: Thursday, 24th September 2020 9:27:02 pm
 * Modified By: Timo Zacherl
 * -----
 * 
 * Copyright © 2020 Timo Zacherl. All rights reserved.
-->

<template>
  <nav>
    <div class="container">
      <div class="logo">
        <router-link to="/">TIMO</router-link>
      </div>
      <div class="nav">
        <div class="nav-start">
          <!--unused-->
        </div>
        <div class="nav-end">
          <a href="https://timozacherl.com" class="nav-link">Personal Page</a>
          <a href="mailto:t.zacherl@icloud.com" class="nav-link">Contact</a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Navbar"
};
</script>

<style lang="scss" scoped>
nav {
  width: 100%;

  .container {
    padding: 1rem 0;
    display: flex;

    @media screen and (max-width: 960px) {
      padding: 1rem;
    }

    .logo {
      margin-inline-end: 2em;
      color: #000;
      font-weight: bold;
      letter-spacing: 5px;
      font-size: 1.4rem;

      a {
        color: inherit;
        text-decoration: none;
        transition: 0.15s ease;
        border-bottom: none;

        &:focus {
          outline: none;
        }

        &:hover {
          letter-spacing: 6px;
          color: lighten($color: #000000, $amount: 50);
        }
      }
    }

    .nav {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .nav-link {
        color: #000;
        text-decoration: none;
        border-bottom: none;

        &:hover {
          color: lighten($color: #000000, $amount: 50);
        }
        &:not(:last-of-type) {
          margin-inline-end: 1rem;
        }
      }
    }
  }
}
</style>
